var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('a-card', {
    staticClass: "column-card box-shadow",
    staticStyle: {
      "min-height": "400px"
    },
    attrs: {
      "bordered": false
    }
  }, [_c('a-tabs', {
    attrs: {
      "tab-position": "left",
      "default-active-key": _vm.currentTab
    },
    on: {
      "change": _vm.getCmsList
    },
    model: {
      value: _vm.currentTab,
      callback: function callback($$v) {
        _vm.currentTab = $$v;
      },
      expression: "currentTab"
    }
  }, [_c('a-tab-pane', {
    key: "1",
    attrs: {
      "tab": "文件通知"
    }
  }, [_c('a-list', {
    attrs: {
      "dataSource": _vm.cmsDataSource
    },
    scopedSlots: _vm._u([{
      key: "renderItem",
      fn: function fn(item) {
        return _c('a-list-item', {
          staticClass: "cms-item",
          on: {
            "click": function click($event) {
              return _vm.toCmsDetail(item);
            }
          }
        }, [_c('span', {
          staticClass: "cms-title"
        }, [_vm._v(_vm._s(item.cmsTitile))]), _c('span', {
          staticClass: "cms-time"
        }, [_vm._v(_vm._s(item.createTime))])]);
      }
    }])
  })], 1), _c('a-tab-pane', {
    key: "2",
    attrs: {
      "tab": "新闻报道"
    }
  }, [_c('a-list', {
    attrs: {
      "dataSource": _vm.cmsDataSource
    },
    scopedSlots: _vm._u([{
      key: "renderItem",
      fn: function fn(item) {
        return _c('a-list-item', {
          staticClass: "cms-item",
          on: {
            "click": function click($event) {
              return _vm.toCmsDetail(item);
            }
          }
        }, [_c('span', {
          staticClass: "cms-title"
        }, [_vm._v(_vm._s(item.cmsTitile))]), _c('span', {
          staticClass: "cms-time"
        }, [_vm._v(_vm._s(item.createTime))])]);
      }
    }])
  })], 1), _c('a-tab-pane', {
    key: "3",
    attrs: {
      "tab": "地方动态"
    }
  }, [_c('a-list', {
    attrs: {
      "dataSource": _vm.cmsDataSource
    },
    scopedSlots: _vm._u([{
      key: "renderItem",
      fn: function fn(item) {
        return _c('a-list-item', {
          staticClass: "cms-item",
          on: {
            "click": function click($event) {
              return _vm.toCmsDetail(item);
            }
          }
        }, [_c('span', {
          staticClass: "cms-title"
        }, [_vm._v(_vm._s(item.cmsTitile))]), _c('span', {
          staticClass: "cms-time"
        }, [_vm._v(_vm._s(item.createTime))])]);
      }
    }])
  })], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };